import {apiService} from "../api.service";
import {AuthModel} from "../../models/auth/auth";

export class AuthService {

    public async auth(data: {username: string, password: string}): Promise<AuthModel> {
        return (await apiService.post<AuthModel>('auth/login_check', {username: data.username, password: data.password}, { baseURL: '' })).data;
    }
}


export const authService = new AuthService();
